import React, { useEffect, useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import { View, Image, Text, TouchableOpacity, StatusBar, Platform } from "react-native";
import * as WebBrowser from "expo-web-browser";
import * as Google from "expo-auth-session/providers/google";
import dimensions from "../../globalStyles/dimensions";
import { Colors } from "../../globalStyles/ColorConfig";
import GlobalStyles from "../../globalStyles/globalStyles";
import CustomComponent from "../../components/CustomComponent";
import AuthIcons from "../../assets/Icons/AuthIcons";
import { styles } from "./auth.style";
import DifferentMethod from "../../modal/AuthModals/DifferentMethod";
import { googleLogin, registerPhone, sendEmail, verifyEmail } from "../../services/Auth/authService";
import { dispatch } from "../../redux/store";
import { setLoggedIn } from "../../redux/auth/authSlice";
import * as Linking from 'expo-linking';
import Animated, { FadeInDown, FadeInUp } from "react-native-reanimated";

type User = {
  idToken?: any;
};

WebBrowser.maybeCompleteAuthSession();

const Auth = ({ navigation }: { navigation: any }) => {
  const [user, setUser] = useState<User | any>({});
  const [isError, setIsError] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };
  const [userInfo, setUserInfo] = useState(null);
  const [clientid, setClientid] = useState('');
  const [isGoogleClicked, setGoogleClicked] = useState(false)


  //client IDs from .env
  const config = {
    androidClientId:
      "728159043990-2vdh4gr9os9qsm95qn771b6rdds340fn.apps.googleusercontent.com",
    iosClientId:
      "728159043990-f5hrhdlt4906a92dqb77jmue416mkq4i.apps.googleusercontent.com",
    webClientId:
      "728159043990-8msa015lv9p27o6ptd323ablobrntjqs.apps.googleusercontent.com",
  };

  const [request, response, promptAsync] = Google.useIdTokenAuthRequest(config);
  
  useEffect(() => {
    if (Platform.OS == 'android') {
      setClientid('728159043990-2vdh4gr9os9qsm95qn771b6rdds340fn.apps.googleusercontent.com')
    }
    else if (Platform.OS == 'web') {
      setClientid('728159043990-8msa015lv9p27o6ptd323ablobrntjqs.apps.googleusercontent.com')
    }
    else {
      setClientid('728159043990-f5hrhdlt4906a92dqb77jmue416mkq4i.apps.googleusercontent.com')
    }
    const fetchData = async () => {
      if(response?.type === 'cancel' || response?.type === 'dismiss'){
        setGoogleClicked(false);
      }

      if (response?.type === "success") {
        const credentials = {
          idToken: response.params.id_token,
          clientId:clientid
        };
        try {
          const googleLoginResponse: any = await googleLogin(credentials);
      
          if (googleLoginResponse?.data?.data.accessToken?.accessTokenJWT) {
            dispatch(
              setLoggedIn({ accessToken: googleLoginResponse?.data?.data.accessToken?.accessTokenJWT, refreshToken: googleLoginResponse?.data?.data.accessToken?.refreshTokenJWT })
            );
          } else {
            navigation.navigate("auth-mobile", {
              mail: googleLoginResponse.data.data.email,
            })
          }
        }
        catch (error) {
          // Handle errors if any
          
        }finally{
          setGoogleClicked(false);
        }
      }
    };
    fetchData();
  }, [response]);

  useEffect(() => {
    WebBrowser.warmUpAsync();
    return () => {
      WebBrowser.coolDownAsync();
    };
  }, []);


  return (
    <>
      <StatusBar
        translucent
        backgroundColor={"transparent"}
        barStyle={"light-content"}
      />
      <View style={styles.Wrapper}>
        <DifferentMethod
          isDialog={true}
          isVisible={isModalVisible}
          toggleModal={toggleModal}
          method1={{}}
          method2={toggleModal}
        />
        <View
          style={{
            height: dimensions.windowHeight / 1.4,
            width: dimensions.windowWidth * 2.4,
          }}
        >
          <Animated.Image
            source={{
              uri: "https://hushl-spark-dev.s3.ap-south-1.amazonaws.com/frontend-assets/onboarding/candles.jpeg",
            }}
            style={styles.BgImg}
            entering={FadeInUp.delay(400)}
          />
          <LinearGradient
            colors={["transparent", Colors.black90]}
            style={{
              position: "absolute",
              width: "100%",
              height: 240,
              bottom: 0,
            }}
          />
        </View>
        <View style={styles.LogoWrapper}>
          <Animated.View entering={FadeInDown.delay(300)}>
            <AuthIcons.LogoText />
          </Animated.View>
        </View>
        <Animated.View entering={FadeInDown.delay(300)}  style={styles.ButtonWrapper}>
          <CustomComponent.AppBtn
            name={"Continue with phone number"}
            icon={<AuthIcons.MobileIcon />}
            style={styles.authBtn}
            textStyle={[
              GlobalStyles.bodyText,
              {
                color: "rgba(255,255,255,0.9)",
                fontFamily: "InterMedium",
                letterSpacing: -0.4,
              },
            ]}
            onPress={() => navigation.navigate("auth-mobile")}
          />
          <CustomComponent.AppBtn
            name={"Continue with e-mail"}
            icon={<AuthIcons.MessageIcon />}
            style={styles.authBtn}
            textStyle={[
              GlobalStyles.bodyText,
              {
                color: "rgba(255,255,255,0.9)",
                fontFamily: "InterMedium",
                letterSpacing: -0.4,
              },
            ]}
            onPress={() => navigation.navigate("auth-email")}
          />
          <CustomComponent.AppBtn
            name={"Continue with Google"}
            icon={<AuthIcons.GoogleIcon />}
            style={styles.authBtn}
            textStyle={[
              GlobalStyles.bodyText,
              {
                color: "rgba(255,255,255,0.9)",
                fontFamily: "InterMedium",
                letterSpacing: -0.4,
              },
            ]}
            onPress={() => {
              setGoogleClicked(true); 
              promptAsync({
                windowFeatures: {
                  prompt: 'select_account'
                }
              });
            }}
            isLoading={isGoogleClicked}
          />
          <CustomComponent.TextView
            title={"By signing up, you agree to our"}
            textStyle={[
              styles.conditiontext,
              {
                color: "rgba(255,255,255,0.5)",
                fontFamily: "InterMedium",
                letterSpacing: -0.4,
              },
            ]}
            boxStyle={[
              styles.boxStyle,
              {
                paddingTop: 8,
              },
            ]}
          >
            <TouchableOpacity onPress={() => Linking.openURL('https://spark.love/terms-conditions')}>
              <Text
                style={[
                  styles.subText,
                  {
                    fontSize: 13,
                    color: "rgba(255,255,255,0.8)",
                    fontFamily: "InterMedium",
                    letterSpacing: -0.4,
                  },
                ]}
              >
                Terms & Conditions
              </Text>
            </TouchableOpacity>
          </CustomComponent.TextView>
        </Animated.View>
      </View>
    </>
  );
};
export default Auth;
